import {
    FETCH_USER_DETAILS_REQUEST,
    FETCH_USER_DETAILS_SUCCESS,
    FETCH_USER_DETAILS_FAILURE,
  } from "./FetchUserdetailsTypes";
  import api from "../../utils/Api";
  
  export const fetchUserDetailsRequest = () => {
    return {
      type: FETCH_USER_DETAILS_REQUEST,
    };
  };
  
  export const fetchUserDetailsSuccess = (userDetails) => {
    return {
      type: FETCH_USER_DETAILS_SUCCESS,
      payload: userDetails,
    };
  };
  
  export const fetchUserDetailsFailure = (error) => {
    return {
      type: FETCH_USER_DETAILS_FAILURE,
      payload: error,
    };
  };
  
  export const fetchUserDetails = (user_id) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchUserDetailsRequest());
      try {
        const response = await api.get(
          "user/" + user_id,
          {
            headers: headers,
          }
        );
        const userDetails = response.data.data;
        dispatch(fetchUserDetailsSuccess(userDetails));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchUserDetailsFailure(errorMsg));
      }
    };
  };
  